"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styled_components_1 = require("styled-components");
var Wrapper = (_a = ["\n\tdisplay: inline-block;\n"], _a.raw = ["\n\tdisplay: inline-block;\n"], styled_components_1.default.div(_a));
var Button = (_b = ["\n\tbackground: #fbfbfb;\n\tcolor: #888;\n\tfont-size: 18px;\n\tborder: 0;\n\tpadding-top: 5px;\n\tvertical-align: text-bottom;\n\theight: 34px;\n\tmin-width: 36px;\n\tfill: #888;\n\tcursor: pointer;\n\toutline: none;\n\n\t&:hover,\n\t&:focus {\n\t\tbackground: #f3f3f3;\n\t}\n"], _b.raw = ["\n\tbackground: #fbfbfb;\n\tcolor: #888;\n\tfont-size: 18px;\n\tborder: 0;\n\tpadding-top: 5px;\n\tvertical-align: text-bottom;\n\theight: 34px;\n\tmin-width: 36px;\n\tfill: #888;\n\tcursor: pointer;\n\toutline: none;\n\n\t&:hover,\n\t&:focus {\n\t\tbackground: #f3f3f3;\n\t}\n"], styled_components_1.default.button(_b));
function createTriggerButton(options) {
    return function (_a) {
        var onClick = _a.onClick, theme = _a.theme;
        return theme ? (React.createElement("div", { className: theme.buttonWrapper },
            React.createElement("button", { onClick: onClick, className: theme.button }, options.child || ''))) : (React.createElement(Wrapper, null,
            React.createElement(Button, { onClick: onClick }, options.child || '')));
    };
}
exports.default = createTriggerButton;
var _a, _b;
